//#region IMPORT
import React, { useState, useRef } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
/** Components Import */
import { Unstable_Grid2 as Grid, Stack, Divider } from '@mui/material';
import { Button, AuthButton, Dialog } from '../../../../Components/MUIs';
/** AG-grid Import */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { FileForm } from '../../../../Components/FileForm/index';
import * as XLSX from 'xlsx';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { flushSync } from 'react-dom';
//#endregion

function LAN_BASIC(props) {
  //#region 변수
  //#endregion
  //#region 웹
  const gridRef1 = useRef();
  //메인 화면 그리드
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 100,
      editable: false,
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'lanId',
      headerName:
        props.lanList.length == 0
          ? ''
          : '*' +
            props.lanList.find(
              (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'LanguageId'
            ).LAN_NM, //언어ID
      minWidth: 120,
      editable: (params) => GridFunctions.isCellEditable(params),
    },
    {
      field: 'lanCd',
      headerName:
        props.lanList.length == 0
          ? ''
          : '*' +
            props.lanList.find(
              (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'LanguageCd'
            ).LAN_NM, //언어코드
      minWidth: 120,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: props.codeList
          .filter((item) => item.groupCd === 'LAN_CD' && item.code != 'LAN_CD')
          .map((item) => item.codeNm),
      },
      cellRenderer: (e) => {
        if (e.value === '') {
          return null;
        } else {
          return e.value;
        }
      },
      editable: (params) => GridFunctions.isCellEditable(params),
    },
    {
      field: 'lanNm',
      headerName:
        props.lanList.length == 0
          ? ''
          : '*' +
            props.lanList.find(
              (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'LanguageNm'
            ).LAN_NM, //언어명
      minWidth: 120,
      flex: 1,
    },
    {
      field: 'lanType',
      headerName:
        props.lanList.length == 0
          ? ''
          : props.lanList.find(
              (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'LanguageType'
            ).LAN_NM, //언어 타입
      minWidth: 120,
    },
  ];
  //#endregion
  //#region 모바일
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    index: 0,
    actions: <></>,
  });
  //BLUNEX
  const [dialogInputs, setDialogInputs] = useState({
    lanId: '',
    lanCd: '',
    lanNm: '',
    lanType: '',
  });
  const dialogRef = useRef({
    lanId: '',
    lanCd: '',
    lanNm: '',
    lanType: '',
  });
  //#endregion

  // ag-grid 컬럼 헤더를 그리드 폭에 맞춤
  const defaultColDef = React.useMemo(() => {
    return {
      wrapHeaderText: true,
      resizable: true,
      sortable: true,
      filter: true,
      editable: true,
      floatingFilter: true,
      flex: 1,
    };
  }, []);

  //#region 나머지 함수
  //업로드 클릭 이벤트
  const appendToGridData = (_rowsToAdd) => {
    let defaultData = [];
    _rowsToAdd.forEach((node) => {
      defaultData.push({ ...node, i: node.no });
    });

    //새로 올린거만 필터 props.rowData 와 비교
    let excelData = defaultData.filter(
      (f) =>
        !props.rowData.some(
          (item) =>
            item.lanId === f.lanId &&
            item.lanCd === f.lanCd &&
            item.lanNm === f.lanNm &&
            item.lanType === f.lanType
        )
    );

    if (
      defaultData.find((f) =>
        props.rowData.some(
          (item) =>
            item.lanId === f.lanId &&
            item.lanCd === f.lanCd &&
            item.lanNm === f.lanNm &&
            item.lanType === f.lanType
        )
      )
    ) {
      props.setSnackbar({
        open: true,
        type: 'error',
        message:
          props.lanList.length == 0
            ? ''
            : props.lanList.find(
                (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'SameItemExists'
              ).LAN_NM, //기존 데이터에 동일한 항목이 있습니다.
      });
    }

    gridRef1.current.api.setRowData(excelData);
    props.setChangedRowData(excelData);
  };

  //그리드에 넣을 데이터 형식으로 변환
  const populateGridData = (_gridData, _headers) => {
    const rowData = _gridData
      .filter((f) => f[1] && f[2])
      .map((row) => {
        const rowObject = {};
        _headers.forEach((header, index) => {
          rowObject[header] = row[index];
        });
        return rowObject;
      });
    return rowData;
  };
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Language"
          printYn='N'
          addClick={() => {
            if (Commons.IsMobile()) {
              //BLUNEX
              setDialogInputs({
                ...dialogInputs,
                lanId: '',
                lanCd: '',
                lanNm: '',
                lanType: '',
              });
              dialogRef.current = {
                lanId: '',
                lanCd: '',
                lanNm: '',
                lanType: '',
              };
              setDialog({
                ...dialog,
                open: true,
                title:
                  props.lanList.length > 0
                    ? props.lanList.filter((f) => f.LAN_ID === 'ViewDtl')[0]
                        .LAN_NM // 상세보기
                    : '',
                index: -1,
                actions: (
                  <Button
                    name={
                      props.lanList.length > 0
                        ? props.lanList.filter((f) => f.LAN_ID === 'Save')[0]
                            .LAN_NM // 저장
                        : ''
                    }
                    onClick={() => {
                      props.SaveLogic2(dialogRef.current);
                      if (dialogRef.current.lanId && dialogRef.current.lanCd) {
                        setDialog({
                          ...dialog,
                          open: false,
                        });
                      }
                    }}
                  />
                ),
              });
            } else {
              GridFunctions.addClick(gridRef1);
            }
          }}
          saveClick={() => props.SaveLogic1()}
          searchClick={(e) => {
            gridRef1.current.api.setQuickFilter(e);
          }}
          deleteClick={() => props.DeleteLogic1()}
          refreshClick={() => props.SearchLogic1()}
          conditions={
            !Commons.IsMobile() && [
              {
                type: 'other',
                title: Commons.IsMobile()
                  ? props.lanList.length == 0
                    ? ''
                    : props.lanList.find(
                        (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                      ).LAN_NM
                  : '', //파일업로드
                name: Commons.IsMobile()
                  ? props.lanList.length == 0
                    ? ''
                    : props.lanList.find(
                        (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                      ).LAN_NM
                  : '', //파일업로드
                item: (
                  <FileForm
                    datas={[
                      {
                        type: 'excel',
                        name:
                          props.lanList.length == 0
                            ? ''
                            : props.lanList.find(
                                (f) =>
                                  f.LAN_TYPE == 'CALL' && f.LAN_ID === 'File'
                              ).LAN_NM, //파일

                        value: props.inputs.mapFile,
                        onChange: (event) => {
                          const fileList = event.target.files;
                          if (Object.keys(fileList).length === 0) return;

                          const file = fileList[0]; // single file upload

                          const reader = new FileReader();
                          reader.readAsArrayBuffer(file);
                          reader.onload = (e) => {
                            const bstr = e.target.result; //string 파일

                            const workBook = XLSX.read(bstr, {
                              type: 'binary',
                            });
                            const workSheetName = workBook.SheetNames[0];

                            const workSheet = workBook.Sheets[workSheetName];
                            const fileData = XLSX.utils.sheet_to_json(
                              workSheet,
                              {
                                header: 1,
                              }
                            );
                            const gridData = fileData.slice(1);

                            //엑셀에서는 headerName으로 들어와서 filed로 바꿔주는 작업
                            for (let i = 0; i < columnDefs.length; i++) {
                              for (let j = 0; j < columnDefs.length; j++) {
                                if (
                                  columnDefs[i].headerName === fileData[0][j]
                                ) {
                                  fileData[0][j] = columnDefs[i].field;
                                  continue;
                                }
                              }
                            }

                            props.setInputs({
                              ...props.inputs,
                              excelData: gridData,
                              header: fileData[0],
                              mapFiles: file,
                              mapFileName: file.name,
                            });
                          };
                          reader.onerror = (error) => {
                            console.log(error);
                            // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                          };
                        },
                        buttonName:
                          props.lanList.length == 0
                            ? ''
                            : props.lanList.find(
                                (f) =>
                                  f.LAN_TYPE == 'CALL' &&
                                  f.LAN_ID === 'FileUpload'
                              ).LAN_NM, //파일업로드
                      },
                      {
                        name:
                          props.lanList.length == 0
                            ? ''
                            : props.lanList.find(
                                (f) =>
                                  f.LAN_TYPE == 'CALL' &&
                                  f.LAN_ID === 'FileName'
                              ).LAN_NM, //파일명
                        value: props.inputs.mapFileName,
                        disabled: true,
                      },
                    ]}
                  />
                ),
              },
              {
                type: 'button',
                name:
                  props.lanList.length == 0
                    ? ''
                    : props.lanList.find(
                        (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Upload'
                      ).LAN_NM, //업로드
                onClick: (e) => {
                  const rowsToAdd = populateGridData(
                    props.inputs.excelData,
                    props.inputs.header
                  );
                  appendToGridData(rowsToAdd);
                },
              },
            ]
          }
          grids={
            <BusinessGridCommon
              gridRef={gridRef1}
              editable={true}
              columnDefs={columnDefs}
              rowData={props.rowData}
              setSelectedRowData={props.setSelectedRowData}
              setChangedRowData={props.setChangedRowData}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default LAN_BASIC;
